import { render, staticRenderFns } from "./Cube.vue?vue&type=template&id=7911fe10&scoped=true&"
import script from "./Cube.vue?vue&type=script&lang=ts&"
export * from "./Cube.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7911fe10",
  null
  
)

export default component.exports